import Debugger from './debugger.ui';

export default Debugger;
